<div class="inner-page-wrapper py-24">
    <span class="text-14 text-grey-400 leading-21" [innerHTML]="safeData()"></span>
</div>
